import type { BackendData, LocalSource } from "@/frontend/types/ehr-clients";

/** Stable, order-independent serialization of sources+groups for change detection. */
export function serializeSources(sources: LocalSource[]): string {
  return JSON.stringify(
    sources
      .map((s) => ({
        u: s.fhir_source,
        g: s.groups.map((x) => ({ id: x.group_id, l: x.label ?? null })).sort((a, b) => a.id.localeCompare(b.id)),
      }))
      .sort((a, b) => a.u.localeCompare(b.u)),
  );
}

/** Map server sources to the local form shape. */
export function toLocalSources(data: BackendData): LocalSource[] {
  return data.sources.map((s) => ({
    fhir_source: s.fhir_source,
    name: s.name,
    logo: s.logo,
    groups: s.groups.map((g) => ({ group_id: g.group_id, label: g.label })),
  }));
}
